<div class="mt-3">
  <h5 [class]="titleClass()">{{ symbol() }} {{ titleKey() | transloco }} ({{ count() }})</h5>
  <p class="text-muted-color text-sm my-1">{{ hintKey() | transloco }}</p>
  <div>
    @for (functionName of functionNames(); track functionName) {
      <span [class]="chipClass()">{{ symbol() }} {{ functionName }}</span>
    } @empty {
      <span class="text-muted-color text-sm">
        {{ 'project.steps.rfi.invitationList.analysis.noFunctionsInGroup' | transloco }}
      </span>
    }
  </div>
</div>
